module.exports = __webpack_public_path__ + "static/media/rou_under_high.72b514d6.png";